<template>
    <div class="modal fade" id="editAddressModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
        <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="exampleModalLongTitle">ویرایش آدرس </h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="row">
                        <div class="col-12">
                            <div class="content-section default">
                                <ul style="color:red;font-size:12px;text-align:center;list-style-type:circle;margin-top:10px;">
                                    <li v-for="error in errors.all()">{{ error }}</li>
                                </ul>
                                <form @submit.prevent="updateAddress" class="form-account">
                                    <div class="row">
                                        <div class="col-sm-12 col-md-12">
                                            <div class="input-group" style="direction:ltr">
                                                <div class="input-group-prepend">
                                                    <button @click="openCitySelectorModal" class="btn btn-outline-secondary" type="button" id="button-addon1" style="margin:0" data-dialog="somedialog">انتخاب</button>
                                                </div>
                                                <input data-vv-as="شهر" type="hidden" v-model="addressInfo.CityId" v-validate="{ required: true}" />
                                                <input style="text-align:right" v-model="addressInfo.FullLocation" readonly="readonly" class="form-control" type="text" aria-label="Example text with button addon">
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-sm-12 col-md-12"> 
                                            <div class="col-sm-6 col-md-6 pull-right">
                                                <div class="form-account-title"> شماره موبایل</div>
                                                <div class="form-account-row">
                                                    <input v-model="addressInfo.TransfereeMobNo" v-validate="{ required: true, regex:/^0\d{10}$/ }" data-vv-as="شماره موبایل" class="input-field" placeholder="شماره موبایل خود را وارد کنید">
                                                </div>
                                            </div>
                                            <div class="col-sm-6 col-md-6 pull-left">
                                                <div class="form-account-title"> نام گیرنده</div>
                                                <div class="form-account-row">
                                                    <input v-model="addressInfo.TransfereeName" v-validate="{required: true , max:50  }" data-vv-as="نام گیرنده" class="input-field" placeholder="نام گیرنده را وارد کنید">
                                                </div>
                                            </div>
                                            <div class="col-sm-6 col-md-6 pull-left">
                                                <div class="form-account-title"> کد پستی</div>
                                                <div class="form-account-row">
                                                    <input v-model="addressInfo.PostalCode" v-validate="{digits:10 }" data-vv-as="کد پستی" class="input-field" placeholder="کد پستی خود را وارد کنید">
                                                </div>
                                            </div>
                                            <div class="col-sm-6 col-md-6 pull-right">
                                                <div class="form-account-title">عنوان آدرس</div>
                                                <div class="form-account-row">
                                                    <input v-model="addressInfo.Title" v-validate="{ required: true, max:20}" data-vv-as="عنوان آدرس" class="input-field aaaa" type="text" placeholder="عنوان آدرس را وارد کنید">
                                                </div>
                                            </div>
                                            <div class="col-sm-12 col-md-12 pull-right">
                                                <div class="form-account-title"> آدرس</div>
                                                <div class="form-account-row">
                                                    <textarea v-model="addressInfo.Address" v-validate="{ required: true, max:300}" data-vv-as=" آدرس" class="input-field aaaa" type="multipy" placeholder="آدرس کامل خود را وارد کنید"></textarea>
                                                </div>
                                            </div>

                                        </div>
                                        <div class="col-sm-6 col-md-6">

                                        </div>
                                    </div>



                                    <div class="col-12 text-center">
                                        <button type="submit" class="btn btn-default btn-lg btn-save">ذخیره</button>
                                        <button data-dismiss="modal" class="btn btn-default btn-lg btn-reject">انصراف</button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
                <div :class="{loader: !isShowLoader, 'loader-bg-black':true}">
                    <img src="/assets/img/loader/loader.svg" />
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    import { httpPromise } from "../../../module/httpUtility";
    import { citySelectorEventBus, addressChangedEventBus } from "../../../eventBus/eventBus"

    export default {
        props: {
            addressInfo: {
                type: Object,
                required: true,
            }
        },
        data() {
            return {
                markers: [],
                cityFullName: '',
                center: { lat: 0, lng: 0 },
                isShowLoader: false
            }
        },
        computed: {
            baseInfo: function () {
                return this.$store.getters.readBaseInfo;
            },
        },
        methods: {

            selectPoint: function (position) {
                var marker = {
                    lat: position.latLng.lat(),
                    lng: position.latLng.lng()
                };
                this.markers = [];
                this.markers.push({ position: marker });
                this.getAreas();
            },
            openCitySelectorModal: function () {
                $(function () {
                    $('#citySelectorModal').modal({ backdrop: 'static', keyboard: false });
                    $('#citySelectorModal').modal('show');
                });
            },
            getAreas() {
                if (this.baseInfo.CityId == this.addressInfo.CityId) {
                    var data = { Lat: this.markers[0].position.lat, Lng: this.markers[0].position.lng }
                    httpPromise(this, '/v1/BasicDefinitions/Areas/ReadByPoint', 'get', data,
                        response => {
                            toastr.remove();
                            toastr.remove();
                            this.addressInfo.AreaId = response.data.Value.AreaId;
                            this.addressInfo.AreaName = response.data.Value.AreaName;
                            this.addressInfo.Lat = data.Lat;
                            this.addressInfo.Lng = data.Lng;
                        },
                        response => {
                            toastr.remove();
                            toastr.error(response.data.Message);
                        });
                }
            },
            updateAddress() {

                this.$validator.validateAll().then(valid => {
                    if (valid) {
                        this.isShowLoader = true;
                        httpPromise(this, '/v1/Identity/CustomersAddress/Update', 'put', JSON.stringify(this.addressInfo),
                            response => {
                                toastr.remove();
                                toastr.success(response.data.Message);
                                addressChangedEventBus.$emit('customerAddressesUpdated', '');
                                this.isShowLoader = false;
                                $(function () {
                                    $('#editAddressModal').modal('hide');
                                });
                            },
                            response => {
                                toastr.remove();
                                toastr.error(response.data.Message);
                                this.isShowLoader = false;
                            });
                    }
                });
            },
            resetForm() {
                this.markers = [];
                this.cityFullName = '';
                this.$validator.reset();
                this.$validator.errors.clear();
            },
            setLatLngToMap() {
                if (this.addressInfo.Lat != null && this.addressInfo.Lng != null) {
                    var marker = {
                        lat: this.addressInfo.Lat,
                        lng: this.addressInfo.Lng
                    };

                    this.markers = [];
                    this.markers.push({ position: marker });
                    this.center = marker;
                } else {
                    var marker = {
                        lat: this.baseInfo.Lat,
                        lng: this.baseInfo.Lng
                    };
                    this.center = marker;
                    this.markers = [];
                }
            }
        },
        created() {
            citySelectorEventBus.$on('cityOnSelected', (data) => {
                this.addressInfo.FullLocation = data.cityFullName;
                this.addressInfo.CityId = data.cityId;
            });
            var resetForm = this.resetForm;
            var setLatLngToMap = this.setLatLngToMap;
            $(function () {
                $('#editAddressModal').on("shown.bs.modal", function (event) {
                    setLatLngToMap();
                });
                $('#editAddressModal').on("hidden.bs.modal", function (event) {
                    resetForm();
                });
            });
        },
        beforeDestroy() {
            citySelectorEventBus.$off('cityOnSelected');
        },
    }
</script>

<style scoped>
    .loader-bg-black {
        position: absolute;
        background-color: #80808033;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        z-index: 9999;
        width: 100%;
        height: 100%
    }

        .loader-bg-black img {
            position: absolute;
            top: 50%;
            left: 48%;
            z-index: 100
        }

    .btn-save {
        background-color: #59b959 !important;
    }

    .btn-reject {
        background-color: #e36e6e !important;
    }

    .input-field {
        padding: 11px 11px 11px 11px !important;
    }

    .modal-content .modal-header button {
        right: unset !important;
        left: 27px !important;
        top: 30px !important;
    }

    .modal-header .close {
        padding: unset !important;
        margin: -1rem -1rem -1rem auto;
    }

    .setaddress {
        padding: 22px !important;
    }

    a:not([href]):not([tabindex]) {
        color: #fff;
    }

    .box.profile .center {
        text-align: center;
    }

    .box.no-address .desc {
        display: block;
        margin: 0 auto;
    }

    .box.profile.no-address img {
        margin-bottom: 25px;
    }

    .box.no-address {
        text-align: center;
        color: #777777;
    }

    .address-div {
        display: contents;
    }

    .box profile {
        min-height: 200px;
        width: auto;
    }

    .box {
        background: #fcfcfc;
        border: 1px solid #e5e5e5;
        -webkit-border-radius: 5px;
        border-radius: 5px;
        padding: 15px;
        width: 100%;
        margin-top: 15px;
    }

        .box .title {
            display: block;
            font-weight: 500;
            text-align: center;
        }

        .box .location {
            font-size: 12px;
            color: #777777;
            display: block;
            text-align: center;
            margin-top: 5px;
        }

        .box .desc {
            margin-top: 15px;
            text-align: center;
            display: block;
            font-size: 12px;
        }

        .box.profile .center {
            text-align: center;
        }

    .btn-lg {
        padding: 10px 25px;
    }
</style>